module.exports = __webpack_public_path__ + "static/media/8763.51e51b06.png";